import { useEffect, useState } from 'react';
import { resolveDeviceId } from '../utils/deviceUtils';

const useResolvedDeviceId = (selectedDevice) => {
  const [resolvedDeviceId, setResolvedDeviceId] = useState('');

  useEffect(() => {
    let cancelled = false;

    resolveDeviceId(selectedDevice).then((id) => {
      if (!cancelled) {
        setResolvedDeviceId(id || '');
      }
    });

    return () => {
      cancelled = true;
    };
  }, [selectedDevice]);

  return resolvedDeviceId;
};

export default useResolvedDeviceId;
